

import {
  Box,
  Button,
  Checkbox,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { ISpeciality } from "../../../models/trainer-registration.model";
import trainerRegistration from "../../../services/trainer/trainerRegistration";


export const SpecialtyFieldModal: React.FC<any> = ({ isOpenFieldSpeciality, onCloseFieldSpeciality, isFieldSpeciality = false, updateFieldSpeciality, reload }: { isOpenFieldSpeciality: any, onCloseFieldSpeciality: any, isFieldSpeciality: boolean, updateFieldSpeciality: any, reload: any }) => {
  const toast = useToast();
  const [specialty, setSpecialty] = useState<ISpeciality[]>([])
  const [selectedSpecialty, setSelectedSpecialty] = useState<string[]>();
  const [loading, isLoading] = useState(false)
  useEffect(() => {
    trainerRegistration
      .getSpecialties()
      .then((response) => {
        setSpecialty(response.data)
        
      })
      .catch((err) => err);
  }, []);

  const cancelRef = useRef().current;

  const assignSpeciality = (role: string, checked: boolean) => {
    let specialty: any[] = [];
    selectedSpecialty !== undefined ? specialty = [...selectedSpecialty] : specialty = [];
    if (checked) {
      specialty.push(role)
      setSelectedSpecialty(specialty)
    } else if (!checked) {
      const ind = specialty.indexOf(parseInt(role))
      specialty.splice(ind, 1)
      setSelectedSpecialty(specialty)

    }
    

  }

  const updateSpeciality = async () => {
    isLoading(true)
    const specialities = {
      type: 'Field',
      specialities: selectedSpecialty
    }

    try {
      const speciality = await trainerRegistration.updateUserSpecialty(specialities);
      if (speciality) {
       reload()
       isLoading(false)
        
        toast({
          title: "Registration",
          description: "Field of specialty updated",
          status: "success",
        })
        onCloseFieldSpeciality()

      }
    } catch (error) {

      toast({
        title: "Registration",
        description: "Something went wrong",
        status: "error",
      })
    }
  }


  return (
    <>
      <Modal
        isOpen={isOpenFieldSpeciality && isFieldSpeciality}
        onClose={onCloseFieldSpeciality}
        scrollBehavior="outside"
        closeOnOverlayClick={true}
        size="xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={3}>
          <ModalHeader>
            <Flex justifyContent='center'>
              <Box>
                <Flex justifyContent='center'>
                  <Text mx='auto' color="#353535" fontSize="20px" fontWeight='800'>
                    Update Field of Speciality
                  </Text>
                </Flex>
                <Text color='#9E9E9E' fontSize="14px">NB: You must specify at least one Field of Specialty</Text>
              </Box>
            </Flex>

          </ModalHeader>
          <ModalCloseButton size="sm" />

          <ModalBody>
            <Box mt={4}>


              {
                specialty.map(each =>
                  <HStack key={each.id} spacing={4} mb='26px'>
                    <Checkbox colorScheme="red" name={each.name} value={each.id} onChange={(e) => assignSpeciality(e.target.value, e.target.checked)} />
                    <Text ml={3} color="#9E9E9E" fontSize='15px'>
                      {each.name}
                    </Text>

                  </HStack>)
              }


              <Flex mt={12} justifyContent="end">
                <HStack>
                  <Button size="sm" px={6} fontSize={12} ref={cancelRef} onClick={() => onCloseFieldSpeciality()}>
                    Cancel
                  </Button>
                  <Button colorScheme="red" type="submit" isLoading={loading} 
                    size="sm" px={6} onClick={() => {updateSpeciality()}} fontSize={12} >SAVE CHANGES</Button>
                </HStack>
              </Flex>

            </Box>


          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
